<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Z4Lwz6/tc-custom/9781615954612.jpg?1733030436765" alt="This image is the cover for the book Leave Tomorrow Behind, Stella Crown Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Leave Tomorrow Behind, Stella Crown Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b>"Clemens will win new readers with this multifaceted crime caper, which makes the most of the 4-H setting"—<i>Booklist</i></b></p><p>Tattooed, hard-working, and often crabby dairy farmer and biker Stella Crown is hot—because it's summer and because she has plenty of things to raise her temperature: a nagging sister-in-law, her fiancé Nick's illness, and a bank account in the red. But when a local country star turns up dead at the county fair where Stella's teenage employee Zach is an exhibitor things turn from hot to ugly.</p><p>Stella had only seen the victim from a distance. But since Stella was the one to dig her out from her deathbed in the calf barn's manure pile, the cops are on her like flies on…well…honey. Why on earth would Stella want to kill a young singer she'd never spoken to?</p><p>Sick to death of annoying cops and entertainment folks, Stella figures the only way to get her life back is to aim law enforcement in the right direction. If that means having to endure a manicure with her soon-to-be-sister-in-law at the dead singer's favorite salon or stopping by the recording studio to check out the talent Stella figures there could be worse things. Can't a simple farm girl just get married in peace?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Judy Clemens
      </h2>
      
      <p class="authorDescription body article"><P>Judy Clemens spends her days in rural Ohio, where she writes, spends time with her family, and eats too much chocolate. She is the author of the Grim Reaper and Stella Crown mysteries, and is a past president of Sisters in Crime.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2716f382